import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../auth/auth.context";

export default function VoiceflowWidget() {
  const isInitialized = useRef(false);
  const location = useLocation();
  const { currentUser } = useAuth() 

  const MyEffectExtension = {
    name: 'ExtensionName',
    type: 'effect',
    match: ({ trace }) => trace.type === 'user_chat',
    effect: async ({ trace }) => {
      // Run your custom logic here
      console.log('Custom effect triggered for trace:', trace);
      window.voiceflow.chat.interact({
        type: "intent",
        payload: {
          intent: { 
            name: 'Change_current_location',
              entities: [
                {
                  name: 'page_url_Text',
                  value: location.pathname
                },
                {
                  name: 'jwt_token',
                  value: currentUser ? await currentUser.getIdToken() : "anonymous"
                }
            ]
          }
        }
      })
    }
  };

  // const syncVariable = async (newPath) => {
  //   try {
  //     if (window.voiceflow && window.voiceflow.chat && isInitialized.current) {
  //       console.log("Location changed:", location.pathname);

  //       window.voiceflow.chat.interact({
  //         type: 'intent',
  //         payload: { intent: { 
  //           name: 'Change_current_location',
  //           entities: [
  //             {
  //               name: 'page_url_Text',
  //               value: newPath
  //             },
  //             {
  //               name: 'jwt_token',
  //               value: currentUser ? await currentUser.getIdToken() : "anonymous"
  //             }
  //           ]
  //       } }
  //     });
  //     }
  
  //   } catch (e) {
  //     console.error("Lỗi đồng bộ biến:", e);
  //   }
  // };

  // useEffect(() => {
  //   // Kiểm tra nếu widget đã load xon  
  //   syncVariable(location.pathname); // Đồng bộ biến mỗi khi location thay đổi
    
  // }, [location]);

  useEffect(() => {
    // Only initialize widget once
    if (!isInitialized.current) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://cdn.voiceflow.com/widget-next/bundle.mjs";

      script.onload = function () {
        window.voiceflow = window.voiceflow || {};
        window.voiceflow.chat.load({
          verify: { projectID: "687f2e865a00d0facf2fc9eb" },
          url: "https://general-runtime.voiceflow.com",
          versionID: "production",
          userId: currentUser ? currentUser.uid : "anonymous",
          voice: {
            url: "https://runtime-api.voiceflow.com",
          },
          assistant: {
            stylesheet: "./vf-custom.css",
            extensions: [MyEffectExtension],
          },
        });

        isInitialized.current = true;
      };

      document.head.appendChild(script);

      // Cleanup when component unmounts
      return () => {
        if (
          window.voiceflow &&
          window.voiceflow.chat &&
          window.voiceflow.chat.destroy
        ) {
          try {
            window.voiceflow.chat.destroy();
          } catch (e) {
            console.warn("Could not destroy voiceflow chat:", e);
          }
        }

        // Remove all voiceflow elements
        const voiceflowElements = document.querySelectorAll(
          "[data-voiceflow], .voiceflow-chat, .vf-chat"
        );
        voiceflowElements.forEach((el) => {
          try {
            el.remove();
          } catch (e) {
            console.warn("Could not remove voiceflow element:", e);
          }
        });

        if (script.parentNode) {
          try {
            script.parentNode.removeChild(script);
          } catch (e) {
            console.warn("Could not remove script:", e);
          }
        }
        isInitialized.current = false;
      };
    }
  }, []); // Empty dependency - only run once

  return null;
}
